/**
 * # Email Regex
 *
 * This regex is used to validate email addresses. Based on http://emailregex.com/ - html5 regex
 */
export type EmailRegex = string;
export const EmailRegexProvider = {
  provide: 'emailRegex',
  useValue:
    '^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$',
};
